export const INIT_STATE = 'INIT_FORGOT_PASSWORD_STATE';

export const POST_FORGOT_PASSWORD_LOADING = 'POST_FORGOT_PASSWORD_LOADING';
export const POST_FORGOT_PASSWORD_SUCCESS = 'POST_FORGOT_PASSWORD_SUCCESS';
export const POST_FORGOT_PASSWORD_ERROR = 'POST_FORGOT_PASSWORD_ERROR';